import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MobileNavigationContextType {
  isNavigationHidden: boolean;
  hideNavigation: () => void;
  showNavigation: () => void;
}

const MobileNavigationContext = createContext<MobileNavigationContextType | undefined>(undefined);

export const useMobileNavigation = () => {
  const context = useContext(MobileNavigationContext);
  if (context === undefined) {
    throw new Error('useMobileNavigation must be used within a MobileNavigationProvider');
  }
  return context;
};

interface MobileNavigationProviderProps {
  children: ReactNode;
}

export const MobileNavigationProvider: React.FC<MobileNavigationProviderProps> = ({ children }) => {
  const [isNavigationHidden, setIsNavigationHidden] = useState(false);

  const hideNavigation = () => {
    setIsNavigationHidden(true);
  };

  const showNavigation = () => {
    setIsNavigationHidden(false);
  };

  return (
    <MobileNavigationContext.Provider value={{ isNavigationHidden, hideNavigation, showNavigation }}>
      {children}
    </MobileNavigationContext.Provider>
  );
};
